// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/global.css'
import 'element-ui/lib/theme-chalk/index.css';
import common from './common';
import ElementUI, { Message } from 'element-ui';
import '@/assets/fonts/fonts.css'
import axios from "axios"
import toast from '@/components/common/toast'
import qhyupload from '@/components/common/qhyupload.vue';
import AppIcon from '@/components/common/AppIcon.vue';
import siteConfig from '@/config/site.js';
import { clearUserProfile } from '@/config/userProfile.js';
Vue.component('qhyupload', qhyupload);
Vue.component('app-icon', AppIcon);
Vue.prototype.$siteConfig = siteConfig;

// 设置页面标题和 meta 标签
document.title = siteConfig.siteTitle;
const descriptionMeta = document.querySelector('meta[name="description"]');
if (descriptionMeta) {
  descriptionMeta.setAttribute('content', siteConfig.siteDescription);
}
const keywordsMeta = document.querySelector('meta[name="keywords"]');
if (keywordsMeta) {
  keywordsMeta.setAttribute('content', siteConfig.siteKeywords);
}
const faviconLink = document.querySelector('link[rel="shortcut icon"]');
if (faviconLink) {
  faviconLink.setAttribute('href', siteConfig.faviconPath);
}

let handlingAuthExpired = false

axios.interceptors.request.use(config => {
  const token = window.localStorage.getItem('token')
  if (!config.headers.Authorization) config.headers.Authorization = token
  if (token) handlingAuthExpired = false
  // console.log(config)
  return config
})

function isAuthExpiredResponse(data) {
  if (!data || Number(data.status) !== 100) return false
  const message = String(data.msg || data.message || '')
  return /token.*(验证失败|无效|失效|过期)|登录.*(失效|过期)|请.*登录/i.test(message)
}

function handleAuthExpired() {
  if (handlingAuthExpired) return
  handlingAuthExpired = true
  window.localStorage.removeItem('token')
  window.localStorage.removeItem('end_time')
  clearUserProfile()

  const currentRoute = router.currentRoute
  if (!currentRoute || currentRoute.path !== '/login') {
    Message.warning('登录已失效，请重新登录')
    router.replace({
      path: '/login',
      query: { redirect: currentRoute && currentRoute.fullPath ? currentRoute.fullPath : '/' }
    }, () => { }, () => { })
  }
}

// 页面可以按请求声明"这次 401 不要全局跳登录"（例如 /buy-cdk 匿名浏览）
function skipAuthRedirect(config) {
  return !!(config && config.skipAuthRedirect)
}

axios.interceptors.response.use(response => {
  // 只有"本来带着 token 的请求"被拒才算登录失效；匿名访问公开页（如 /buy-cdk）
  // 拿到鉴权失败时不要强制跳登录页，交给页面自己按未登录展示
  if (isAuthExpiredResponse(response.data) && window.localStorage.getItem('token')
    && !skipAuthRedirect(response.config)) {
    handleAuthExpired()
    return Promise.reject(new Error('登录已失效'))
  }
  return response
}, error => {
  if (error && error.response && error.response.status === 401
    && window.localStorage.getItem('token') && !skipAuthRedirect(error.config)) {
    handleAuthExpired()
  }
  return Promise.reject(error)
})

Vue.prototype.$ajax_upload = axios
axios.defaults.baseURL = 'https://video.kissxx.cn/'
Vue.prototype.$ajax = axios
Vue.prototype.$msg = Message
Vue.config.productionTip = false
Vue.prototype.$loadinginfo = {
  lock: true,
  text: '加载中...',
  background: 'rgba(255, 255, 255, 0.8)'
}
Vue.prototype.common = common
Vue.prototype.$callrecord = {
  status: 0
};
Vue.use(toast)
Vue.use(ElementUI);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js